import { useEffect, useState } from "react";
import { Input, Form, DatePicker, Select } from "antd";
import "./AddEmployeeModal.scss";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Chair } from "../../../assets/images";
import dayjsTZ from "../../../utils/dayjs";
import { useSelector } from "react-redux";

const { Option } = Select;
const { TextArea } = Input;

const GeneralInformations = () => {
  const { programFields } = useSelector((state) => state.programFields);
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [team, setTeam] = useState({});
  const [name, setName] = useState("");
  const [value, setValue] = useState("");
  const [genderType, setGenderType] = useState({});

  //* finds the gender from programFields and sets the genderType state
  useEffect(() => {
    const employeeGender = programFields?.find(
      (res) => res?.fieldName === "Gjinia"
    );
    setGenderType(employeeGender);

    const companyTeam = programFields?.find(
      (res) => res?.fieldName === "Employee Team"
    );
    setTeam(companyTeam);
  }, [programFields]);

  return (
    <div className="generalInfoContainer">
      <div className="form">
        <Form.Item
          className="input-label"
          name="employeeFirstName"
          label="Emri"
          rules={[
            {
              required: true,
              message: "Emri punonjësit është i detyrueshëm",
            },
          ]}
        >
          <Input
            autoComplete="off"
            allowClear
            onChange={(e) => setName(e.target.value)}
            className="input-form"
            placeholder="Shkruaj emrin e punonjësit"
          />
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeeFathersName"
          label="Atësia"
          rules={[
            {
              required: true,
              message: "Atësia e punonjësit është e detyrueshme",
            },
          ]}
        >
          <Input
            autoComplete="off"
            allowClear
            className="input-form"
            placeholder="Shkruaj atësinë e punonjësit"
          />
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeeLastName"
          label="Mbiemri"
          rules={[
            {
              required: true,
              message: "Mbiemri punonjësit është i detyrueshëm",
            },
          ]}
        >
          <Input
            autoComplete="off"
            allowClear
            className="input-form"
            placeholder="Shkruaj mbiemrin e punonjësit"
          />
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeeGender"
          label="Gjinia"
          rules={[
            {
              required: true,
              message: "Mbiemri punonjësit është i detyrueshëm",
            },
          ]}
        >
          <Select
            className="select-3"
            placeholder="Selekto gjininë e punonjësit"
            allowClear
            classNames={{ popup: { root: isDarkMode ? "darkDropdown" : undefined } }}
          >
            {genderType?.fieldOptions?.map((gender) => (
              //* maps employeeGender
              <Option value={gender} key={gender}>
                {gender}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeeDayOfBirth"
          label="Ditëlindja"
        >
          <DatePicker
            allowClear
            format="DD/MM/YYYY"
            className="birthdate"
            classNames={{ popup: { root: isDarkMode ? "darkDropdown" : undefined } }}
            // disabledDate={disabledDate}
            placeholder="Selekto ditëlindjen e punonjësit"
          />
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeePersonalNumber"
          label="Numri Personal (ID)"
        >
          <Input
            autoComplete="off"
            allowClear
            className="input-form"
            placeholder="Shkruaj numrin personal të punonjësit"
          />
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeePhoneNumber"
          label="Numri Telefonit"
        >
          <PhoneInput
            regions={"europe"}
            country="al"
            placeholder="Vendos numrin e telefonit"
            value={value}
            onChange={setValue}
            masks={{ al: "... ... ..." }}
            autoComplete="off"
          />
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeePersonalEmail"
          label="Email Personal"
        >
          <Input
            className="input-form"
            autoComplete="off"
            allowClear
            placeholder="Shkruaj emailin e punonjësit"
          />
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeeAddress"
          label="Adresa"
        >
          <TextArea autoComplete="off" allowClear className="inputAddress" />
        </Form.Item>
        <Form.Item
          className="input-label"
          name="employeeTeam"
          label="Team"
          rules={[
            {
              required: true,
              message: "Team që punon punonjësi është i detyrueshëm",
            },
          ]}
        >
          <Select
            className="select-3"
            placeholder="Ku punon ky punonjës"
            allowClear
            classNames={{ popup: { root: isDarkMode ? "darkDropdown" : undefined } }}
          >
            {team?.fieldOptions?.map((val) => (
              <Option value={val} key={val}>
                {val}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <img className="images" src={Chair} alt="Chair" />
      <div className="span">
        <span className="showName">{name}</span>
      </div>
    </div>
  );
};

export default GeneralInformations;
